function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _path, _g;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgCardManager = function SvgCardManager(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 144,
    fill: "none",
    viewBox: "0 0 168 144"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("mask", {
      id: "a",
      width: 138,
      height: 93,
      x: 15,
      y: 26,
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: "luminance"
      },
      children: _path || (_path = /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M152.365 26H15v92.894h137.365z"
      }))
    }), _g || (_g = /*#__PURE__*/_jsxs("g", {
      mask: "url(#a)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#C4C4C4",
        d: "M28.328 77.086c-.83 0-1.646-.391-2.156-1.123a2.617 2.617 0 0 1 .654-3.647l6.613-4.597a2.626 2.626 0 0 1 3.652.653 2.617 2.617 0 0 1-.654 3.646l-6.613 4.597c-.457.318-.98.47-1.497.47z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#E84D4F",
        d: "m36.143 67.09-.416.716a.894.894 0 0 0 .326 1.223.897.897 0 0 0 1.224-.326l.417-.717a.894.894 0 0 0-.326-1.223.897.897 0 0 0-1.226.326"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#00D639",
        d: "M39.146 74.673a3.916 3.916 0 0 0 3.92-3.913 3.916 3.916 0 0 0-3.92-3.913 3.916 3.916 0 0 0-3.92 3.913 3.916 3.916 0 0 0 3.92 3.913"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#00D639",
        d: "m41.139 69.578-.002-.22c4.925-.062 9.191-2.082 12.676-6 3.636-4.092 5.543-9.27 6.502-12.893 1.196-5.042 1.851-9.403 2.062-13.723l.22.011c-.212 4.334-.868 8.708-2.07 13.766-.965 3.649-2.884 8.861-6.55 12.985-3.527 3.968-7.847 6.012-12.838 6.075z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#474747",
        d: "M17.27 118.894q-.184 0-.375-.031a2.26 2.26 0 0 1-1.862-2.602l4.87-29.175a5.014 5.014 0 0 1 4.763-4.17 4.973 4.973 0 0 1 5.164 4.674l1.89 26.195a2.265 2.265 0 0 1-4.518.325L25.31 87.902l-.001-.024a.473.473 0 0 0-.935-.049l-4.872 29.175a2.266 2.266 0 0 1-2.232 1.89"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#474747",
        d: "M30.863 115.555h1.22a.228.228 0 0 0 0-.455h-1.22a.228.228 0 1 0 0 .455M18.77 118.314h1.221a.227.227 0 1 0 0-.454h-1.22a.228.228 0 1 0 0 .454"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#E84D4F",
        d: "M27.437 69.842a1.013 1.013 0 0 0-1.342-.495 1.01 1.01 0 1 0 1.12 1.648c.304-.29.407-.75.22-1.153zM39.32 70.682l-.26.962a1.078 1.078 0 0 0 2.08.563l.26-.962a1.078 1.078 0 0 0-2.08-.563"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#C4C4C4",
        d: "M34.671 82.577c-.369 0-.742-.077-1.095-.24l-8.63-3.96a2.617 2.617 0 0 1-1.287-3.473 2.624 2.624 0 0 1 3.48-1.286l6.646 3.05 2.965-4.204a2.627 2.627 0 0 1 3.656-.633 2.617 2.617 0 0 1 .635 3.65l-4.223 5.985a2.63 2.63 0 0 1-2.147 1.11"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#C6C6C6",
        d: "M25.106 85.256q-.47-.104-.942-.202c-1.822-.379-3.104-2.211-2.76-4.656q.567-2.994 1.25-5.98c.428-1.465 2.618-2.77 4.778-2.302q.552.119 1.099.244c2.15.493 3.3 2.524 2.654 4.41a163 163 0 0 0-1.818 5.821c-.573 1.903-2.448 3.064-4.262 2.665"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#777",
        d: "M72.484 33.336h-.22V76.2h.22zM84.836 33.669h-.22v42.866h.22zM100.289 31.79h-.221v42.866h.221zM118.052 33.958h-.22v42.865h.22zM139.781 33.292h-.22v42.865h.22z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#303030",
        d: "M139.796 97.67c6.942 0 12.57-5.619 12.57-12.55 0-6.93-5.628-12.548-12.57-12.548s-12.569 5.618-12.569 12.549 5.627 12.548 12.569 12.548"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#474747",
        d: "M117.795 92.74c5.195 0 9.406-4.203 9.406-9.39 0-5.186-4.211-9.39-9.406-9.39s-9.406 4.204-9.406 9.39 4.211 9.39 9.406 9.39"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#5E5E5E",
        d: "M100.095 90.291c4.579 0 8.291-3.705 8.291-8.276s-3.712-8.277-8.291-8.277-8.29 3.706-8.29 8.276c0 4.572 3.711 8.277 8.29 8.277"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#777",
        d: "M84.866 87.71c3.795 0 6.87-3.07 6.87-6.858s-3.075-6.859-6.87-6.859-6.87 3.071-6.87 6.859 3.076 6.859 6.87 6.859"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#919191",
        d: "M72.321 85.298a5.64 5.64 0 0 0 5.643-5.634 5.64 5.64 0 0 0-5.643-5.634 5.64 5.64 0 0 0-5.643 5.634 5.64 5.64 0 0 0 5.643 5.634"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#1B1B1B",
        d: "M56.328 34.008v2.787c0 .858.7 1.55 1.559 1.545l90.873-.621a1.547 1.547 0 0 0 1.538-1.545v-8.628c0-.897-.761-1.605-1.657-1.541l-90.874 6.461c-.81.058-1.439.731-1.439 1.542"
      })]
    }))]
  }));
};
export default SvgCardManager;